// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__DiwV+","navigate":"Menu_navigate__KJg9b","main":"Menu_main__Ri-1R"};